:host {
  --form-field-input-width: 240px;
  height: auto;
}

.form-section,
.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
}

.sub-module {
  margin-left: 26px;
}

.sub-module-section {
  gz-form-field {
    &::part(form-field-label) {
      min-width: 224px;
      max-width: 224px;
    }
  }
}

.form-section {
  margin-top: calc(var(--spacer) * 2.5);

  .flex-group {
    display: flex;
    align-items: flex-start;

    gz-form-field:first-of-type {
      min-width: var(--form-field-label-width);
    }

    .company-label {
      width: 283px;
      min-width: var(--form-field-label-width);
      color: var(--chart-300-icon-buttons);
    }
  }

  #settingsUninstallPasswordSectionGroup {
    margin-bottom: 22px;
  }
}

#useCustomPathFormField {
  --margin-bottom-wrapper: 0px;
  gz-checkbox {
    margin-top: var(--spacer);
  }
}

#password-info {
  max-width: 230px;
  padding-top: calc(var(--spacer));
}

#settings-targets {
  margin-left: 26px;
  max-width: 844px;
}
